import React from 'react';

class Loading extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  state = {
  };

  render = () => {
    if (this.props.isLoading) {
      return (
        <div className='Loading'>
          <p className='Loading__placeholder'>Loading …</p>
        </div>
      );
    }

    return this.props.children
  }
}

export default Loading;
